import { AxiosPromise } from 'axios';
import { IMedispanApprovedDiff } from 'models/application-manager/medispan/IMedispanApprovedDiff';
import { IMedispanStagingDiffResponse } from 'models/application-manager/medispan/IMedispanStagingDiff';
import { IMedispanStagingReview } from 'models/application-manager/medispan/IMedispanStagingReview';
import { TypedHttp } from 'services/typed-http';

const BASE_URL = '/application-manager/medispan-staging';

export class MedispanStagingClient {
  static getStagingDiff = (): AxiosPromise<IMedispanStagingDiffResponse> =>
    TypedHttp.GetPromise<IMedispanStagingDiffResponse>(`${BASE_URL}/diff`);

  static getStatus = (): AxiosPromise<IMedispanStagingReview> =>
    TypedHttp.GetPromise<IMedispanStagingReview>(`${BASE_URL}/status`);

  static approve = (): AxiosPromise<void> =>
    TypedHttp.PostPromise<object, void>(`${BASE_URL}/approve`, {});

  static reject = (reason: string): AxiosPromise<void> =>
    TypedHttp.PostPromise<{ reason: string }, void>(`${BASE_URL}/reject`, { reason });

  static executeUpdate = (): AxiosPromise<void> =>
    TypedHttp.PostPromise<object, void>(`${BASE_URL}/execute`, {});

  static getReviewedDiffs = (): AxiosPromise<IMedispanApprovedDiff[]> =>
    TypedHttp.GetPromise<IMedispanApprovedDiff[]>(`${BASE_URL}/reviewed`);
}
